import { useLocation, useNavigate } from 'react-router-dom';
import { PageCard } from '../../components/page-card/PageCard';
import { TitleContainer } from '../../components/title-container/TitleContainer';
import IPage from '../../interfaces/IPage';
import { BackdropCustom } from '../../components/backdrop/Backdrop';
import { Button, DialogActions, Grid, TextField } from '@mui/material';
import { useState } from 'react';
import IFormError from '../../interfaces/IFormError';
import * as yup from 'yup';
import { useValidateSchema } from '../../services/useValidateSchema';
import React from 'react';
import { Form } from '../../components/form/Form';
import { useToastr } from '../../hooks/useToastr';
import { useCustomerPortalUserService } from '../../services/useCustomerPortalUserService';
import { useAuth } from '../../hooks/auth';
import { ICustomerPortalUpdateUser } from '../../interfaces/ICustomerPortalUpdateUser';
import { useCustomerPortalUsersService } from '../../services/useCustomerPortalUsersService';

const CustomerPortalUserForm: React.FC<IPage> = ({ title }) => {
  window.document.title = title;

  const { findCustomerPortalUserById } = useCustomerPortalUserService();
  const { updateCustomerPortalUser } = useCustomerPortalUsersService();
  const auth = useAuth();
  const tenantDomain = auth.state.tenantDomain;
  const navigate = useNavigate();
  const validateSchema = useValidateSchema();
  const location = useLocation();
  const toastr = useToastr();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<IFormError>({});

  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState<string | null>('');
  const [email, setEmail] = useState<string | null>('');

  const queryParams = new URLSearchParams(location.search);
  // const idCustomer = queryParams.get('id-customer');

  const schema = yup.object({
    name: yup.string().required('Campo obrigatório'),
    email: yup.string().required('Campo obrigatório'),
    phoneNumber: yup.string().required('Campo obrigatório'),
  });

  const toListUsers = () => {
    const idCustomer = queryParams.get('id-customer');
    idCustomer !== null
      ? navigate(`/customer-portal-users-list?id-customer=${idCustomer}`)
      : navigate(`/customer-portal-users-list`);
  };

  const updateCustomerUser = async (customerPortalUser: ICustomerPortalUpdateUser) => {
    setLoading(true);
    await updateCustomerPortalUser(customerPortalUser)
      .then(() => {
        toastr.success('Usuário atualizado com sucesso');
        toListUsers();
      })
      .catch(error => {
        toastr.error(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = async () => {
    const customerPortalUser: ICustomerPortalUpdateUser = {
      id,
      name,
      phoneNumber,
      email,
    };

    const result = await validateSchema.validate(schema, customerPortalUser);
    if (!result.isValid) {
      setErrors(result.errors ? result.errors : {});
      return;
    }

    if (id) {
      await updateCustomerUser(customerPortalUser);
    }
  };

  const list = async () => {
    const id = location.pathname.replace('/customer-portal-user-form', '').replace('/', '');

    if (id) {
      setLoading(true);
      await findCustomerPortalUserById(`${id}`, tenantDomain)
        .then(customerPortalUser => {
          setId(customerPortalUser.customerPortalUser.id);
          setName(customerPortalUser.customerPortalUser.name);
          setPhoneNumber(customerPortalUser.customerPortalUser.phoneNumber);
          setEmail(customerPortalUser.customerPortalUser.email);
        })
        .catch(error => {
          console.log(error);
          toastr.error(error.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  React.useEffect(() => {
    list();
  }, []);

  return (
    <>
      <TitleContainer>
        <h1>Cliente</h1>
      </TitleContainer>
      <PageCard>
        <Form>
          {loading && <BackdropCustom />}
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} sm={6}>
              <TextField
                sx={{ width: '100%' }}
                size="small"
                label="Nome"
                value={name}
                onChange={e => setName(e.target.value)}
                autoComplete="off"
                helperText={errors.name}
                error={!!errors.name}
              />
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
              <TextField
                sx={{ width: '100%' }}
                size="small"
                label="Email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                helperText={errors.email}
                error={!!errors.email}
              />
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
              <TextField
                sx={{ width: '100%' }}
                size="small"
                label="Número de telefone"
                value={phoneNumber}
                onChange={e => setPhoneNumber(e.target.value)}
                helperText={errors.phoneNumber}
                error={!!errors.phoneNumber}
              />
            </Grid>
          </Grid>

          <DialogActions>
            <Button onClick={() => toListUsers()} color="inherit" disabled={loading}>
              Cancelar
            </Button>
            <Button onClick={() => handleSubmit()}>Confirmar</Button>
          </DialogActions>
        </Form>
      </PageCard>
    </>
  );
};

export default CustomerPortalUserForm;
